import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse, HttpParams } from '@angular/common/http';
import { throwError, Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ErrorHandler } from '@angular/core';
import { environment } from '../../../environments/environment';
import { PagoSolicitudReembolso, Respuesta } from '../models';

@Injectable({
  providedIn: 'root'
})
export class ReportesService {

  url = environment.api;
  constructor(private http: HttpClient, private errorHandler: ErrorHandler) {}

  obtenerListaReportePeriodoPago() {
    return this.http.get(`${this.url}PagoColaborador`).pipe(
      map((response: Respuesta) => response)
      ,
      catchError((error: HttpErrorResponse) => {
        this.errorHandler.handleError(error);
        return throwError(() => new Error('Error al obtener el detalle del usuario'));
      })
    );
  }

  generarExcelPeriodoPago( { fecha_inicio, fecha_fin, search }: { fecha_inicio: Date, fecha_fin: Date, search: string }) {
    const fechaInicioFormatted = fecha_inicio.toISOString().split('T')[0];
    const fechaFinFormatted = fecha_fin.toISOString().split('T')[0];
    const params = new HttpParams()
            .set('fechaInicio', fechaInicioFormatted)
            .set('fechaFin', fechaFinFormatted)
            .set('busqueda', search || '');
    return this.http.get(`${this.url}PagoColaborador/Excel`, { params, responseType: 'blob' });
  }

  generarExcelIncidencias( { fecha_inicio, fecha_fin, search }: { fecha_inicio: Date, fecha_fin: Date, search: string }) {
    const fechaInicioFormatted = fecha_inicio.toISOString().split('T')[0];
    const fechaFinFormatted = fecha_fin.toISOString().split('T')[0];
    const params = new HttpParams()
            .set('fechaInicio', fechaInicioFormatted)
            .set('fechaFin', fechaFinFormatted)
            .set('busqueda', search || '');
    return this.http.get(`${this.url}PagoColaborador/reporte-incidencias`, { params, responseType: 'blob' });
  }

  generarExcelBeneficioNoEjecutado( anio: number | null | undefined ) {
    const params = new HttpParams().set('anio', anio || new Date().getFullYear().toString());
    return this.http.get(`${this.url}Colaborador/beneficio-no-ejecutado/Excel`, { params, responseType: 'blob' });
  }

  obtenerGraficoBeneficioNoEjecutado(): Observable<any> {
    return this.http.get(`${this.url}PagoColaborador/seguimiento-saldo-sgmm`);
  }

  actualizarReportes(registros: PagoSolicitudReembolso[]): Observable<any> {
    let IDs = registros.map(registro => registro.id);
    return this.http.patch(`${this.url}PagoColaborador`, IDs).pipe(
      map((response: Respuesta) => response)
    );
  }

}
